import * as React from "react";
import Popover from "@mui/material/Popover";
import OrbPopoverProps from "./orb-popover-interface";

const OrbPopover = (props:OrbPopoverProps) => {
  const { open, anchorTarget, onClose ,children,id} =props
 
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorTarget}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
   
      sx={{
        "& .MuiPaper-root": {
          backgroundColor:  'rgb(56, 45, 64)', 
          color: "white",        
          border: "1px solid rgba(255, 255, 255, 0.2)"  ,  
          padding: "8px 12px",
        },
      }}
    >
     <div  >
        {children}
      </div>
    </Popover>
  );
};

export default OrbPopover;

